export const SortByMenuStyleProps = {
  PaperProps: {
    sx: {
      marginTop: '4px',
      boxShadow: `
          rgb(255, 255, 255) 0px 0px 0px 0px,
          rgba(0, 0, 0, 0.05) 0px 0px 0px 1px,
          rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
          rgba(0, 0, 0, 0.05) 0px 4px 6px -2px
        `,
      '& .MuiList-root': {
        padding: 0,
      },

      '& .MuiMenuItem-root': {
        borderRadius: '6px',
        marginTop: 8,
        minWidth: 120,
        color: '#363636',
        fontSize: '14px',
        height: '38px',
        margin: '0',
        '&:hover': {
          backgroundColor: '#BF295C',
          color: 'white',
        },
        '&.Mui-selected, &.Mui-selected:hover': {
          backgroundColor: 'transparent',
          color: '#BF295C',
        },
      },
    },
  },
};